"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionsService = void 0;
var Subscriptions_json_1 = __importDefault(require("@orbs-network/orbs-ethereum-contracts-v2/build/contracts/Subscriptions.json"));
var mainnetAddresses_1 = require("../mainnetAddresses");
var MAIN_NET_SUBSCRIPTION_CONTRACT_ADDRESS = mainnetAddresses_1.ORBS_MAIN_NET_CONTRACT_ADDRESSES.subscriptionsContract;
var SubscriptionsService = /** @class */ (function () {
    function SubscriptionsService(web3, subscriptionsContractAddress) {
        if (subscriptionsContractAddress === void 0) { subscriptionsContractAddress = MAIN_NET_SUBSCRIPTION_CONTRACT_ADDRESS; }
        this.web3 = web3;
        this.subscriptionsContract = new this.web3.eth.Contract(Subscriptions_json_1.default.abi, subscriptionsContractAddress);
    }
    SubscriptionsService.prototype.setFromAccount = function (defaultAccountAddress) {
        this.subscriptionsContract.options.from = defaultAccountAddress;
    };
    SubscriptionsService.prototype.readVcData = function (vcid) {
        return __awaiter(this, void 0, void 0, function () {
            var rawResponse, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsContract.methods
                            .getVcData(vcid)
                            .call()];
                    case 1:
                        rawResponse = _a.sent();
                        response = rawResponse;
                        return [2 /*return*/, response];
                }
            });
        });
    };
    SubscriptionsService.prototype.readVcIdFromHistory = function (blockNumber, ownerId) {
        return __awaiter(this, void 0, void 0, function () {
            var events, event, vcId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.subscriptionsContract.getPastEvents("VcCreated", {
                            address: ownerId,
                            fromBlock: blockNumber,
                            toBlock: blockNumber,
                        })];
                    case 1:
                        events = _a.sent();
                        event = events[0];
                        vcId = event.returnValues.vcId;
                        return [2 /*return*/, {
                                owner: ownerId,
                                vcId: vcId,
                            }];
                }
            });
        });
    };
    SubscriptionsService.prototype.readVcCreatedEvents = function (ownerId, startFromBlock) {
        return __awaiter(this, void 0, void 0, function () {
            var pastEventOptions, events, vcCreatedEvents;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        pastEventOptions = {
                            address: ownerId,
                            fromBlock: 0,
                        };
                        if (startFromBlock !== undefined) {
                            pastEventOptions.fromBlock = startFromBlock;
                        }
                        return [4 /*yield*/, this.subscriptionsContract.getPastEvents('VcCreated', pastEventOptions)];
                    case 1:
                        events = _a.sent();
                        vcCreatedEvents = events.map(function (event) {
                            var vcCreatedEvent = {
                                vcId: event.returnValues.vcId
                            };
                            return vcCreatedEvent;
                        });
                        return [2 /*return*/, vcCreatedEvents];
                }
            });
        });
    };
    return SubscriptionsService;
}());
exports.SubscriptionsService = SubscriptionsService;
//# sourceMappingURL=SubscriptionsService.js.map